import { configurationSettings } from '../../../../configuration/configuration-settings';
import { browsingDomainStore } from '../../store';
export const hasMaximumSelectedSites = () => {
    const selectedSiteIds = browsingDomainStore.data.selectedSiteIds;
    const maximumSelectedSites = configurationSettings.data.browsing.maximumSelectedSites;
    return selectedSiteIds.length >= maximumSelectedSites;
};
//# sourceMappingURL=has-maximum-selected-sites.js.map